import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { referral } from "../../services/api";

/** Notes a partner's ?ref=CODE from any page, so a later booking is credited to them. */
export default function ReferralCapture() {
  const { search } = useLocation();
  useEffect(() => {
    const code = new URLSearchParams(search).get("ref");
    if (code) referral.capture(code);
  }, [search]);
  return null;
}
